import { render, staticRenderFns } from "./InvoiceEntrance.vue?vue&type=template&id=83cddd4e&scoped=true&"
import script from "./InvoiceEntrance.vue?vue&type=script&lang=js&"
export * from "./InvoiceEntrance.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceEntrance.vue?vue&type=style&index=0&id=83cddd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cddd4e",
  null
  
)

export default component.exports